import { render, staticRenderFns } from "./RxTextField.vue?vue&type=template&id=36795907"
import script from "./RxTextField.vue?vue&type=script&lang=js"
export * from "./RxTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports